import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import * as React from 'react';
import { Provider } from 'react-redux';

import { FeedbackFormContainer } from '../FeedbackForm';
import { TechProblemsContainer } from '../TechProblems';
import { IApplicationContext } from '../../types/application';
import { ApplicationContext } from '../../utils/applicationContext';
import { IReduxStore } from '../../types/redux';

export interface IApplicationProps {
  reduxStore: IReduxStore;
  context: IApplicationContext;
}

export const Application: React.FC<IApplicationProps> = props => {
  const { context, reduxStore } = props;

  return (
    <ErrorLogComponent logger={context.logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={context.custom.initialDeviceType}>
          <Provider store={reduxStore}>
            <FeedbackFormContainer />
            <TechProblemsContainer />
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
